import { useEffect, useState } from "react";
import { APIConstants, PatientStatementsConstants } from "../utilities/Constants";

const APIDebugTest = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const testAPICall = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const testToken = localStorage.getItem("sAuthToken") || "test-token";
      const testPracticeID = localStorage.getItem("practiceID") || "1";

      // Simple GET endpoint - no parameters
      const url = `${APIConstants.BASE_URL_BILLING}${PatientStatementsConstants.GetStatementWorkflowSummary}`;

      console.log("🔍 Testing API Call");
      console.log("URL:", url);
      console.log("Token:", testToken);

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${testToken}`,
          "Content-Type": "application/json",
        },
      });

      console.log("Response Status:", res.status);
      console.log("Response Headers:", {
        contentType: res.headers.get("content-type"),
      });

      const rawText = await res.text();
      console.log("Raw Response Text:", rawText);

      let parsed = null;
      try {
        parsed = JSON.parse(rawText);
      } catch (e) {
        console.error("Failed to parse JSON:", e);
      }

      setResponse({
        status: res.status,
        statusText: res.statusText,
        rawText: rawText,
        parsed: parsed,
      });
    } catch (err) {
      console.error("❌ Error:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Auto-test on page load
    testAPICall();
  }, []);

  return (
    <div style={{ padding: "20px", fontFamily: "monospace" }}>
      <h1>🧪 API Debug Test</h1>

      <div style={{ marginBottom: "20px" }}>
        <button
          onClick={testAPICall}
          disabled={loading}
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Testing..." : "Test API"}
        </button>
      </div>

      {error && (
        <div style={{ background: "#fee", padding: "10px", marginBottom: "20px", borderRadius: "4px" }}>
          <strong>❌ Error:</strong> {error}
        </div>
      )}

      {response && (
        <div style={{ background: "#f0f0f0", padding: "15px", borderRadius: "4px" }}>
          <h3>Response Details:</h3>
          <p>
            <strong>Status:</strong> {response.status} {response.statusText}
          </p>
          <h4>Raw Response:</h4>
          <pre
            style={{
              background: "#fff",
              padding: "10px",
              overflow: "auto",
              maxHeight: "300px",
              border: "1px solid #ccc",
            }}
          >
            {response.rawText}
          </pre>

          <h4>Parsed JSON:</h4>
          <pre
            style={{
              background: "#fff",
              padding: "10px",
              overflow: "auto",
              maxHeight: "300px",
              border: "1px solid #ccc",
            }}
          >
            {JSON.stringify(response.parsed, null, 2)}
          </pre>

          {response.parsed && (
            <div>
              <h4>Field Values:</h4>
              <ul>
                <li>PendingReviewCount: {response.parsed?.PendingReviewCount}</li>
                <li>ApprovedCount: {response.parsed?.ApprovedCount}</li>
                <li>RejectedCount: {response.parsed?.RejectedCount}</li>
                <li>GeneratedCount: {response.parsed?.GeneratedCount}</li>
              </ul>
            </div>
          )}
        </div>
      )}

      <h3 style={{ marginTop: "20px" }}>Configuration:</h3>
      <p>
        <strong>Base URL:</strong> {APIConstants.BASE_URL_BILLING}
      </p>
      <p>
        <strong>Endpoint:</strong> {PatientStatementsConstants.GetStatementWorkflowSummary}
      </p>
      <p>
        <strong>Token (from localStorage):</strong> {localStorage.getItem("sAuthToken") || "NOT SET"}
      </p>
      <p>
        <strong>PracticeID (from localStorage):</strong> {localStorage.getItem("practiceID") || "NOT SET"}
      </p>

      <h3>Instructions:</h3>
      <ol>
        <li>Open browser console (F12)</li>
        <li>Check for any API errors or response details</li>
        <li>Verify the API URL is correct</li>
        <li>Check if the API response contains the expected fields (PendingReviewCount, etc.)</li>
      </ol>
    </div>
  );
};

export default APIDebugTest;
